<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn text icon v-on="on">
        <v-icon color="light-grey">{{`${icon}`}}</v-icon>
      </v-btn>
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'primary-tool-tip',
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-information-outline',
    },
  },
}
</script>
